<section class="header-section bg-grey">
    <div class="container section-spacing">
        <div class="row mx-0 align-items-center">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <h1 class="header-title text-start mb-0">
                    <span>Infraon Assets
                        for <br /> Manufacturing</span>
                </h1>
                <p class="header-desc text-start mx-0 w-100" style="margin: 24px 0">
                    Your Partner in Precision Asset Management.
                </p>

            </div>
        </div>
    </div>
</section>

<section class="container section-spacing feature-1-section">
    <div class="main-feature-wrapper section-spacing" style="background-position: top right 50px">
        <div class="feature-1-content-wrapper">
            <h2 class="section-title">What is Assets for Manufacturing?</h2>
            <p class="section-paragraph">
                Assets is a comprehensive asset management solution tailored to the
                manufacturing sector, including automobile, electronics, and oil &
                gas industries. This advanced tool streamlines asset management,
                ensuring efficiency, reliability, and cost-effectiveness in
                manufacturing operations.
            </p>
            <p class="section-paragraph mb-0">
                By integrating cutting-edge technology, Infraon Assets provides a
                holistic approach to managing a wide range of physical and digital
                assets within these industries.
            </p>
        </div>
    </div>
    <div class="main-feature-wrapper section-spacing" style="background-position: top left 50px">
        <div class="feature-1-content-wrapper">
            <h2 class="section-title">
                What does Asset Management do for Manufacturing?
            </h2>
            <p class="section-paragraph">
                Infraon Assets serves as a centralized platform for manufacturing
                industries to track, manage, and maintain their assets effectively.
                This includes monitoring the health of machinery, scheduling regular
                maintenance, and ensuring compliance with industry standards.
            </p>
            <p class="section-paragraph mb-0">
                It's designed to optimize the lifecycle of assets, reduce downtime,
                and enhance operational efficiency, particularly in sectors like
                automobile manufacturing, electronics production, and oil & gas
                exploration and processing.
            </p>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
        Key Benefits of Assets for Manufacturing
    </h2>

    <div class="row mx-0 align-items-center section-spacing pt-0">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Efficiency Enhancement</h3>
                <p class="section-paragraph">
                    By centralizing asset data, manufacturers can streamline
                    operations, reducing downtime and improving production efficiency.
                    This software enables real-time tracking of assets, facilitating
                    quicker decision-making and more effective utilization of
                    resources, thereby enhancing overall productivity.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-3.webp"
                class="w-100" alt="efficiency Enhancement" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-4.webp"
                class="w-90" alt="cost Reduction" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Cost Reduction</h3>
                <p class="section-paragraph">
                    The software aids in identifying underperforming assets and
                    preventing equipment failures, leading to significant cost
                    savings. By enabling predictive maintenance, manufacturers can
                    avoid expensive repairs and downtime, ensuring smoother operations
                    and extended asset life, thus reducing total expenditure on
                    assets.
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Asset Lifecycle Management</h3>
                <p class="section-paragraph">
                    Asset Management Software provides a comprehensive view of an
                    asset's lifecycle, from acquisition to disposal. This helps in
                    better planning for asset replacement and understanding the total
                    cost of ownership, ensuring optimal asset utilization and
                    investment.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-5.webp"
                class="w-100" alt="asset lifecycle management" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-6.webp"
                class="w-90" alt="Quality control and compliance" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Quality Control and Compliance</h3>
                <p class="section-paragraph">
                    The software helps maintain high standards of quality control by
                    monitoring assets continuously. It also ensures compliance with
                    various industry regulations and standards by keeping accurate
                    records, providing audit trails, and enabling easy reporting.
                </p>
            </div>
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-left">
                <h3 class="section-title">Inventory Optimization</h3>
                <p class="section-paragraph">
                    By tracking inventory levels and usage patterns, the software
                    helps optimize stock levels, reducing the likelihood of
                    overstocking or stockouts. This results in lower inventory costs
                    and an improved ability to meet production demands efficiently.
                </p>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-7.webp"
                class="w-100" alt="inventory Optimization" />
        </div>
    </div>

    <div class="row mx-0 align-items-center section-spacing pb-0 reverse-column">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img loading="lazy"
                src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/assets-manufacturing-feature-8.webp"
                class="w-90" alt="Asset management in manufacturing." />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div class="illustrated-feature-container-text-right">
                <h3 class="section-title">Data-Driven Decision Making</h3>
                <p class="section-paragraph">
                    The software provides valuable insights through data analytics and
                    reporting tools. This data-driven approach enables manufacturers
                    to make informed decisions about asset procurement, maintenance,
                    and deployment, improving operational strategies and business
                    outcomes.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm depreciation-calculator d-flex align-items-center justify-content-between primary-bg">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="100" class="section-title text-start text-white">
                Introducing Our Asset <br />
                Depreciation Calculator 📉
            </h2>
            <p data-aos="fade-up" data-aos-delay="300" class="section-paragraph text-start text-white">
                Optimize your financial planning with our latest tool! <br />
                Easily calculate asset depreciation and make informed <br />
                decisions for your business.
            </p>
            <a routerLink="/free-tools/asset-depreciation-calculator/" class="text-white">
                <span>Click here to explore</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15" fill="none">
                    <path
                        d="M17.2968 5.51799L12.4968 0.717991C11.562 -0.218009 10.038 -0.218009 9.10316 0.717991C8.64956 1.17039 8.39996 1.77399 8.39996 2.41479C8.39996 3.05559 8.64956 3.65919 9.10316 4.11159L12.2064 7.21479L9.10316 10.318C8.64956 10.7716 8.39996 11.374 8.39996 12.0148C8.39996 12.6556 8.64956 13.258 9.10316 13.7116C9.55676 14.1652 10.1592 14.4148 10.8 14.4148C11.4408 14.4148 12.0432 14.1652 12.4968 13.7116L17.2968 8.91159C17.7504 8.45919 18 7.85559 18 7.21479C18 6.57399 17.7504 5.97039 17.2968 5.51799ZM16.4484 8.06319L11.6484 12.8632C11.1936 13.3168 10.4064 13.3168 9.95156 12.8632C9.48356 12.3952 9.48356 11.6344 9.95156 11.1664L13.9032 7.21479L9.95156 3.26319C9.72476 3.03639 9.59996 2.73519 9.59996 2.41479C9.59996 2.09439 9.72476 1.79319 9.95156 1.56639C10.1856 1.33239 10.4928 1.21479 10.8 1.21479C11.1072 1.21479 11.4144 1.33239 11.6484 1.56519L16.4484 6.36519C16.6752 6.59319 16.8 6.89439 16.8 7.21479C16.8 7.53519 16.6752 7.83639 16.4484 8.06319Z"
                        fill="white" />
                    <path
                        d="M8.8968 5.51799L4.0968 0.717991C3.162 -0.218009 1.638 -0.218009 0.7032 0.717991C0.2496 1.17039 0 1.77399 0 2.41479C0 3.05559 0.2496 3.65919 0.7032 4.11159L3.8064 7.21479L0.7032 10.318C0.2496 10.7716 0 11.374 0 12.0148C0 12.6556 0.2496 13.258 0.7032 13.7116C1.1568 14.1652 1.7592 14.4148 2.4 14.4148C3.0408 14.4148 3.6432 14.1652 4.0968 13.7116L8.8968 8.91159C9.3504 8.45919 9.6 7.85559 9.6 7.21479C9.6 6.57399 9.3504 5.97039 8.8968 5.51799ZM8.0484 8.06319L3.2484 12.8632C2.7936 13.3168 2.0064 13.3168 1.5516 12.8632C1.0836 12.3952 1.0836 11.6344 1.5516 11.1664L5.5032 7.21479L1.5516 3.26319C1.3248 3.03639 1.2 2.73519 1.2 2.41479C1.2 2.09439 1.3248 1.79319 1.5516 1.56639C1.7856 1.33239 2.0928 1.21479 2.4 1.21479C2.7072 1.21479 3.0144 1.33239 3.2484 1.56519L8.0484 6.36519C8.2752 6.59319 8.4 6.89439 8.4 7.21479C8.4 7.53519 8.2752 7.83639 8.0484 8.06319Z"
                        fill="white" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="container section-spacing features">
    <h2 class="section-title p-b-60 mb-0">
        Using Infraon Assets for Manufacturing
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="28" height="27"
                    viewBox="0 0 28 27" fill="none">
                    <path
                        d="M0 21.875C0 21.1641 0.546875 20.5625 1.3125 20.5625H4.53906C5.08594 18.8125 6.78125 17.5 8.75 17.5C10.6641 17.5 12.3594 18.8125 12.9062 20.5625H26.6875C27.3984 20.5625 28 21.1641 28 21.875C28 22.6406 27.3984 23.1875 26.6875 23.1875H12.9062C12.3594 24.9922 10.6641 26.25 8.75 26.25C6.78125 26.25 5.08594 24.9922 4.53906 23.1875H1.3125C0.546875 23.1875 0 22.6406 0 21.875ZM5.5 21.625C5.5 20.6953 9.67969 21.3181 8.75 21.3181C7.76562 21.3181 11.3198 20.9453 11.3198 21.875C11.3198 22.8594 7.76562 21.875 8.75 21.875C9.67969 21.875 5.5 22.6094 5.5 21.625ZM26.6875 3.0625C27.3984 3.0625 28 3.66406 28 4.375C28 5.14062 27.3984 5.6875 26.6875 5.6875H14.6562C14.1094 7.49219 12.4141 8.75 10.5 8.75C8.53125 8.75 6.83594 7.49219 6.28906 5.6875H1.3125C0.546875 5.6875 0 5.14062 0 4.375C0 3.66406 0.546875 3.0625 1.3125 3.0625H6.28906C6.83594 1.3125 8.53125 0 10.5 0C12.4141 0 14.1094 1.3125 14.6562 3.0625H26.6875ZM12.6992 4.375C12.6992 5.35938 9.41406 4.375 10.3984 4.375C11.3281 4.375 12.25 5.35938 12.25 4.375C12.25 3.44531 11.3281 4.375 10.3984 4.375C9.41406 4.375 12.6992 3.44531 12.6992 4.375Z"
                        fill="#084CD4" />
                    <path
                        d="M19.25 8.625C21.1641 8.625 22.8594 9.9375 23.4062 11.6875H26.6875C27.3984 11.6875 28 12.2891 28 13C28 13.7656 27.3984 14.3125 26.6875 14.3125H23.4062C22.8594 16.1172 21.1641 17.375 19.25 17.375C17.2812 17.375 15.5859 16.1172 15.0391 14.3125H1.3125C0.546875 14.3125 0 13.7656 0 13C0 12.2891 0.546875 11.6875 1.3125 11.6875H15.0391C15.5859 9.9375 17.2812 8.625 19.25 8.625ZM21 12.625C21 11.6953 22.4297 12.625 21.5 12.625C20.5156 12.625 23 12.1953 23 13.125C23 14.1094 16.5156 12.625 17.5 12.625C18.4297 12.625 21 13.6094 21 12.625Z"
                        fill="#AC67F0" />
                </svg>
                <h3 class="section-title text-start">
                    Automated Asset Discovery and Management
                </h3>
                <p class="section-paragraph text-start">
                    Automatically discovers and manages all types of assets, making it
                    easier for companies in the automobile and electronics sectors to
                    keep track of their extensive and diverse inventory.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="29" height="29"
                    viewBox="0 0 29 29" fill="none">
                    <path
                        d="M12.25 7.875C12.25 3.55469 15.75 0 20.125 0C21.1641 0 22.1484 0.21875 23.0234 0.601562L18.375 5.25V9.625H22.75L27.3984 4.97656C27.7812 5.85156 28 6.83594 28 7.875C28 11.2656 25.8672 14.1094 22.9141 15.2578L20.4531 12.7969L19.25 11.5391L17.9922 12.7969L17.5547 13.2344L12.25 7.92969V7.875ZM0 22.75L9.1875 13.5625L13.1797 17.5547L12.7422 18.0469L11.4844 19.25L12.7422 20.5078L5.25 28L0 22.75ZM7.49219 22.3125L5.6875 20.5078L3.82812 22.3125L5.6875 24.1719L7.49219 22.3125Z"
                        fill="#084CD4" />
                    <path
                        d="M16.1953 18.0547L9.14062 11H5.75L0.5 4L4 0.5L11 5.75V9.19531L18.0547 16.1953L19.75 14.5L28.5 23.25L23.25 28.5L14.5 19.75L16.1953 18.0547Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title text-start">
                    Predictive Maintenance Capabilities
                </h3>
                <p class="section-paragraph text-start">
                    Utilizes predictive analytics to foresee potential breakdowns or
                    failures in machinery, which is particularly beneficial for the
                    oil & gas industry where equipment reliability is critical.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="26" height="23"
                    viewBox="0 0 26 23" fill="none">
                    <path
                        d="M0 14.625C0 13.3047 1.06641 12.1875 2.4375 12.1875H8.9375C10.2578 12.1875 11.375 13.3047 11.375 14.625V20.3125C11.375 21.6836 10.2578 22.75 8.9375 22.75H2.4375C1.06641 22.75 0 21.6836 0 20.3125V14.625ZM15.4375 0H23.5625C24.8828 0 26 1.11719 26 2.4375V4.0625C26 5.43359 24.8828 6.5 23.5625 6.5H15.4375C14.0664 6.5 13 5.43359 13 4.0625V2.4375C13 1.11719 14.0664 0 15.4375 0ZM13 10.5625C13 9.24219 14.0664 8.125 15.4375 8.125H23.5625C24.8828 8.125 26 9.24219 26 10.5625V12.1875C26 13.5586 24.8828 14.625 23.5625 14.625H15.4375C14.0664 14.625 13 13.5586 13 12.1875V10.5625ZM15.4375 16.25H23.5625C24.8828 16.25 26 17.3672 26 18.6875V20.3125C26 21.6836 24.8828 22.75 23.5625 22.75H15.4375C14.0664 22.75 13 21.6836 13 20.3125V18.6875C13 17.3672 14.0664 16.25 15.4375 16.25Z"
                        fill="#A8C0F1" />
                    <path
                        d="M0 2.5625C0 1.24219 1.06641 0.125 2.4375 0.125H8.9375C10.2578 0.125 11.375 1.24219 11.375 2.5625V8.25C11.375 9.62109 10.2578 10.6875 8.9375 10.6875H2.4375C1.06641 10.6875 0 9.62109 0 8.25V2.5625Z"
                        fill="#1A5AD9" />
                </svg>
                <h3 class="section-title text-start">
                    Customizable Dashboards and Reporting
                </h3>
                <p class="section-paragraph text-start">
                    Offers customizable dashboards and detailed reporting features,
                    providing manufacturing managers in sectors like electronics and
                    automobiles with the insights they need to make informed
                    decisions.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="20" height="23"
                    viewBox="0 0 20 23" fill="none">
                    <path
                        d="M19.625 2.13281L19.5703 2.07812C19.2969 1.85938 18.6953 1.47656 17.7656 1.14844C15.9062 0.492188 13.1172 0 10 0C6.82812 0 4.03906 0.492188 2.17969 1.14844C1.25 1.47656 0.648438 1.85938 0.375 2.07812V2.13281V6.94531C1.08594 7.32812 2.07031 7.71094 3.32812 8.03906C5.1875 8.47656 7.48438 8.75 10 8.75C12.4609 8.75 14.7578 8.47656 16.6172 8.03906C17.875 7.71094 18.8594 7.32812 19.625 6.94531V2.13281ZM19.625 9.84375C18.8594 10.1172 18.0938 10.3906 17.2188 10.6094C15.1406 11.1016 12.625 11.375 10 11.375C7.32031 11.375 4.80469 11.1016 2.72656 10.6094C1.85156 10.3906 1.08594 10.1172 0.375 9.84375V13.9453C1.08594 14.3281 2.07031 14.7109 3.32812 15.0391C5.1875 15.4766 7.48438 15.75 10 15.75C12.4609 15.75 14.7578 15.4766 16.6172 15.0391C17.875 14.7109 18.8594 14.3281 19.625 13.9453V9.84375ZM0.265625 2.1875C0.210938 2.24219 0.210938 2.24219 0.210938 2.24219L0.265625 2.1875ZM19.7344 2.24219C19.7344 2.24219 19.7344 2.24219 19.6797 2.1875L19.7344 2.24219Z"
                        fill="#084CD4" />
                    <path
                        d="M0.164062 20.7578C0.4375 20.9766 1.03906 21.3594 1.96875 21.6875C3.82812 22.3438 6.61719 22.7812 9.73438 22.7812C12.9062 22.7812 15.6953 22.3438 17.5547 21.6875C18.4844 21.3594 19.0859 20.9766 19.3594 20.7578L19.4141 20.7031V16.875C18.6484 17.1484 17.8828 17.4219 17.0078 17.6406C14.9297 18.1328 12.4141 18.4062 9.73438 18.4062C7.10938 18.4062 4.59375 18.1328 2.51562 17.6406C1.64062 17.4219 0.875 17.1484 0.109375 16.875V20.7031L0.164062 20.7578ZM19.5234 20.5938L19.4688 20.6484C19.5234 20.5938 19.5234 20.5938 19.5234 20.5938ZM0.0546875 20.6484C0.0546875 20.5938 0 20.5938 0 20.5938L0.0546875 20.6484Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title text-start">
                    Integration with Existing Systems
                </h3>
                <p class="section-paragraph text-start">
                    Infraon Assets seamlessly integrates with existing ERP and CRM
                    systems, enhancing data accuracy and efficiency across all
                    manufacturing operations.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="28" height="33"
                    viewBox="0 0 28 33" fill="none">
                    <rect x="3" y="2.5" width="22" height="28" rx="3" fill="#A8C0F1" />
                    <path
                        d="M0 5C0 2.26562 2.1875 0 5 0H22.5C25.2344 0 27.5 2.26562 27.5 5V27.5C27.5 30.3125 25.2344 32.5 22.5 32.5H5C2.1875 32.5 0 30.3125 0 27.5V5ZM5 6.25V26.25C5 26.9531 5.54688 27.5 6.25 27.5H21.25C21.875 27.5 22.5 26.9531 22.5 26.25V6.25C22.5 5.625 21.875 5 21.25 5H6.25C5.54688 5 5 5.625 5 6.25Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title text-start">Mobile Asset Management</h3>
                <p class="section-paragraph text-start">
                    Offers a mobile solution that allows staff to manage and monitor
                    assets on-the-go, crucial for industries like oil & gas where
                    assets are spread across remote locations.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12">
            <div class="feature-wrapper">
                <svg style="max-height: 26px" xmlns="http://www.w3.org/2000/svg" width="30" height="27"
                    viewBox="0 0 30 27" fill="none">
                    <path
                        d="M10.8333 13.4999C12.1875 13.4999 13.3333 14.6601 13.3333 16.0312V24.4687C13.3333 25.8925 12.1875 26.9999 10.8333 26.9999C9.42708 26.9999 8.33333 25.8925 8.33333 24.4687V16.0312C8.33333 14.6601 9.42708 13.4999 10.8333 13.4999ZM2.5 20.2499C3.85417 20.2499 5 21.4101 5 22.7812V24.4687C5 25.8925 3.85417 26.9999 2.5 26.9999C1.09375 26.9999 0 25.8925 0 24.4687V22.7812C0 21.4101 1.09375 20.2499 2.5 20.2499Z"
                        fill="#AC67F0" />
                    <path
                        d="M30 2.53125C30 1.16016 28.8542 0 27.5 0C26.0938 0 25 1.16016 25 2.53125V24.4688C25 25.8926 26.0938 27 27.5 27C28.8542 27 30 25.8926 30 24.4688V2.53125Z"
                        fill="#1A5AD9" />
                    <path
                        d="M19.1667 6.75C17.7604 6.75 16.6667 7.91016 16.6667 9.28125V24.4688C16.6667 25.8926 17.7604 27 19.1667 27C20.5209 27 21.6667 25.8926 21.6667 24.4688V9.28125C21.6667 7.91016 20.5209 6.75 19.1667 6.75Z"
                        fill="#1A5AD9" />
                </svg>
                <h3 class="section-title text-start">
                    Sustainable Asset Management
                </h3>
                <p class="section-paragraph text-start">
                    Promotes environmentally sustainable practices by optimizing asset
                    usage and reducing waste, which is essential for all manufacturing
                    sectors, especially in today’s eco-conscious world.
                </p>
            </div>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO
                credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white">Start now</a>
        </div>
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="it-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/itam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Asset Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a
                routerLink="/assets/img/feature-pages/infraon-assets/asset-manufacturing/software-assets-management-solutions">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/sam-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="Software Asset Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">
                            Software Asset Management
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-4">
            <a routerLink="/itsm-tool">
                <div class="backlink-wrapper">
                    <div class="backlink-thumbnail-wrapper">
                        <img src="/assets/img/feature-pages/infraon-assets/asset-manufacturing/itsm-thumbnail-01.webp"
                            class="w-100 backlink-thumbnail" alt="IT Service Management Thumbnail" />
                    </div>
                    <div class="backlink-container bg-white">
                        <p class="section-title-s text-start">IT Service Management</p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>